import CertificatesModal from './CertificatesModal';

export default CertificatesModal;
